import { FunctionComponent } from 'react';
import { Typography } from 'aqui';

type PreviewBannerProps = {
    show: boolean;
    text?: string;
    percentLoaded: number;
};

const PreviewBanner: FunctionComponent<PreviewBannerProps> = ({
    show,
    text = '',
    percentLoaded
}) => {
    return (
        <Typography
            type="body3"
            tag="div"
            className={`pdf-viewer__message ${ show &&'pdf-viewer__message--show'}`}
        >
          <span>
              {text}
          </span>
          <span className="pdf-viewer__message__percent">
              {percentLoaded}%
          </span>
        </Typography>
    );
};

export default PreviewBanner;
